import {
  type IconDefinition,
  type IconName,
  type IconPrefix,
} from '@fortawesome/fontawesome-svg-core';

export const facStars = {
  prefix: 'fac' as IconPrefix,
  iconName: 'stars' as IconName,
  icon: [
    16,
    16,
    [],
    null,
    'M7.657 6.247c.11-.33.576-.33.686 0l.645 1.937a2.89 2.89 0 0 0 1.829 1.828l1.936.645c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 0 0-1.828 1.829l-.645 1.936a.361.361 0 0 1-.686 0l-.645-1.937a2.89 2.89 0 0 0-1.828-1.828l-1.937-.645a.361.361 0 0 1 0-.686l1.937-.645a2.89 2.89 0 0 0 1.828-1.828l.645-1.937zM3.794 1.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387A1.734 1.734 0 0 0 4.593 5.69l-.387 1.162a.217.217 0 0 1-.412 0L3.407 5.69A1.734 1.734 0 0 0 2.31 4.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387A1.734 1.734 0 0 0 3.407 2.31l.387-1.162zM10.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732L9.1 2.137a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L10.863.1z',
  ],
} as unknown as IconDefinition;

export const facZendesk = {
  prefix: 'fac' as IconPrefix,
  iconName: 'zendesk' as IconName,
  icon: [
    256,
    200,
    [],
    null,
    'M118.25 51.23v142.78H0L118.25 51.23Zm0-51.23A59.14 59.14 0 0 1 0 0h118.25Zm19.5 194a59.1 59.1 0 0 1 59.13-59.12A59.12 59.12 0 0 1 256 194.01H137.75Zm0-51.26V0H256L137.75 142.74Z',
  ],
} as unknown as IconDefinition;
